import React from 'react';
import { Callout, Flex, FlexColumn, Grid, Select as BaseSelect, Text } from 'core/components';
import { CAPABILITIES_DEFAULT_CONFIGS } from '@kentik/ui-shared/agents/constants';

const FlowExportInstructionTable = ({
  hostName,
  displayName,
  host,
  port,
  deviceName,
  indent = false,
  instructions
}) => {
  let hostStr = <Text fontWeight="bold">{host || '<kproxy_ip_address>'}</Text>;

  if (host === CAPABILITIES_DEFAULT_CONFIGS?.kproxy?.args?.host) {
    hostStr = (
      <Text as="div" fontWeight="bold">
        Any IP on {displayName || hostName} host
      </Text>
    );
  }
  instructions = instructions || (
    <Text as="div">
      Configure {deviceName ? <strong>{deviceName}</strong> : 'this device'} to send flows to Kentik with the following
      details:
    </Text>
  );
  return (
    <>
      <Text as="div" fontWeight="bold">
        Flow Export Instructions
      </Text>
      {instructions}
      <Grid ml={indent ? 2 : 0} gridTemplateColumns="80px 1fr" mt={1}>
        <Text as="div">Private IP:</Text>
        {hostStr}
        <Text as="div">Port:</Text>
        <Text as="div" fontWeight="bold">
          {port || '<kproxy_port>'}
        </Text>
      </Grid>
    </>
  );
};

// For device Dialog
const FlowExportInstructionsForm = ({
  hostName,
  displayName,
  host,
  port,
  deviceName,
  flowProxyId,
  handleFlowProxySelect,
  ariaProps = {},
  agentOptions = []
}) => (
  <Flex flexDirection="column" gap="12px" {...ariaProps}>
    <BaseSelect
      menuWidth={310}
      placeholder="Select a Universal Agent (w/ Kproxy running) to show the private IP below"
      options={agentOptions}
      onChange={handleFlowProxySelect}
      values={flowProxyId}
    />
    {host && port && (
      <FlowExportInstructionTable
        hostName={hostName}
        displayName={displayName}
        host={host}
        port={port}
        deviceName={deviceName}
        indent
      />
    )}
  </Flex>
);

// Version for Agents page
const FlowExportInstructions = ({ latestConfig, agent }) => {
  const { host, port } = latestConfig?.argsObject ?? {};
  if (!host || !port) {
    return null;
  }
  const hostName = agent?.get('host_name');
  const displayName = agent?.get('display_name');
  const instructions = <Text>To send flow telemetry through this proxy, please configure devices to:</Text>;

  return (
    <FlexColumn justifyContent="space-between" mt="12px">
      <Callout intent="primary" p={2}>
        <FlowExportInstructionTable
          hostName={hostName}
          displayName={displayName}
          host={host}
          port={port}
          instructions={instructions}
        />
      </Callout>
    </FlexColumn>
  );
};

export { FlowExportInstructions, FlowExportInstructionTable, FlowExportInstructionsForm };
